export default {
    AdminError: "Sorry! Something went wrong. kindly contact your administrator",
    connectivity: "Check your internet connectivity or may be right now server is down. kindly contact your administrator",
    AuthError: "Your authorization token is invalid or expired",
    NoRecords: "No Records Found"
}


// WEBPACK FOOTER //
// ./src/helpers/constantMessage.js